import { AppState } from 'state/types';

import getParentState from '../selectors';

export function getLeaderboardState(state: AppState) {
  return getParentState(state).projectLeaderboard;
}

export default getLeaderboardState;
